import React, {useEffect, useState} from "react";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {useParams} from 'react-router-dom';
import {baseUrl, formatDateTime, ipAddress, userLocation, userName} from '../../Univ.js'
import SpeechRecognition, {useSpeechRecognition} from "react-speech-recognition";
function ConsultNotes(props) {
    const {ip_id} = useParams();
    const [ipData, setIpData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDateTime, setSelectedDateTime] = useState(new Date());
    const [cnotesData, setcnotesData] = useState([]);
    const [consData, setConsData] = useState([]);
    const [departments, setDepartments] = useState('');
    const [conNoteData, setconNoteData] = useState({
        "ip": '',
        "cons": '',
        "notes": '',
        "notes_time": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    const [language, setLanguage] = useState('');
    const [activeField, setActiveField] = useState(null); // which textarea is currently listening
    const [transcripts, setTranscripts] = useState({
        allergy: '', illness: '', complaints: '', diagnosis: '', diet: '', physio: '', examination: ''
    });
    const {transcript, resetTranscript} = useSpeechRecognition({continuous: true});
    useEffect(() => {
        if (!activeField) return;
        setTranscripts(prev => ({
            ...prev, [activeField]: transcript
        }));
    }, [transcript, activeField]);
    const startListeningForField = (fieldName) => {
        setActiveField(fieldName);    // mark which field is active
        resetTranscript();            // clear previous transcript
        SpeechRecognition.startListening({continuous: true, language});
    };
    const stopListening = () => {
        SpeechRecognition.stopListening();
        setActiveField(null);  // no active field
    };
    const departmentFields = {
        CARDIOLOGY: [{name: 'chest_pain_type', label: 'Chest Pain Type (Typical/Atypical)'}, {
            name: 'onset_duration', label: 'Onset & Duration'
        }, {name: 'palpitation', label: 'Palpitation'}, {
            name: 'dyspnea', label: 'Breathlessness (Dyspnea)'
        }, {name: 'syncope', label: 'Syncope'}, {name: 'ecg_findings', label: 'ECG Findings'}, {
            name: 'echo_findings', label: 'ECHO Findings'
        }, {name: 'risk_factors', label: 'Risk Factors (DM/HTN/Smoking)'}, {
            name: 'indication', label: 'Indication (Reason for Procedure)'
        }, {name: 'procedure_type', label: 'Procedure Type (Angiogram/Angioplasty)'}, {
            name: 'access_site', label: 'Access Site (Radial/Femoral)'
        }, {name: 'vessel_involved', label: 'Vessel Involved (LAD/RCA/LCX)'}, {
            name: 'lesion_details', label: 'Lesion Details'
        }, {name: 'stent_used', label: 'Stent Used (Type/Size)'}, {
            name: 'balloon_used', label: 'Balloon Used'
        }, {name: 'complications', label: 'Complications'}, {
            name: 'contrast_volume', label: 'Contrast Volume Used (ml)'
        }, {name: 'fluoro_time', label: 'Fluoroscopy Time'}, {
            name: 'hemodynamics', label: 'Hemodynamics (BP/HR)'
        }, {name: 'post_procedure_plan', label: 'Post Procedure Plan'}, {
            name: 'pre_procedure_diagnosis', label: 'Pre-Procedure Diagnosis'
        }, {name: 'post_procedure_diagnosis', label: 'Post-Procedure Diagnosis'}, {
            name: 'closure_device', label: 'Closure Device Used'
        }, {name: 'anticoagulation', label: 'Anticoagulation Given'},],
        ORTHOPAEDICS: [{name: 'joint_pain_site', label: 'Joint Pain Site'}, {
            name: 'pain_duration', label: 'Pain Duration'
        }, {name: 'swelling', label: 'Swelling'}, {name: 'tenderness', label: 'Tenderness'}, {
            name: 'range_of_motion', label: 'Range of Motion'
        }, {name: 'fracture_history', label: 'Fracture History'}, {
            name: 'deformity', label: 'Deformity'
        }, {name: 'implant_history', label: 'Implant / Surgery History'},],
        PSYCHIATRIS: [{name: 'mood', label: 'Mood'}, {name: 'affect', label: 'Affect'}, {
            name: 'thought_content', label: 'Thought Content'
        }, {name: 'hallucination', label: 'Hallucination'}, {
            name: 'sleep_pattern', label: 'Sleep Pattern'
        }, {name: 'appetite', label: 'Appetite'}, {
            name: 'suicidal_ideas', label: 'Suicidal Ideation'
        }, {name: 'insight', label: 'Insight & Judgment'},],
        DERMATOLOGY: [{name: 'lesion_type', label: 'Lesion Type'}, {
            name: 'site_distribution', label: 'Site / Distribution'
        }, {name: 'itching', label: 'Itching'}, {name: 'duration', label: 'Duration'}, {
            name: 'pigmentation', label: 'Pigmentation Changes'
        }, {name: 'infection_signs', label: 'Infection Signs'}, {name: 'allergy_history', label: 'Allergy History'},],
        GASTROENTRO_SURGERY: [{name: 'abdominal_pain_site', label: 'Abdominal Pain Site'}, {
            name: 'pain_character', label: 'Pain Character'
        }, {name: 'vomiting', label: 'Vomiting'}, {
            name: 'bowel_changes', label: 'Bowel Habit Changes'
        }, {name: 'bleeding_pr', label: 'Bleeding PR'}, {
            name: 'weight_loss', label: 'Weight Loss'
        }, {name: 'endoscopy_findings', label: 'Endoscopy Findings'},],
        UROLOGY: [{name: 'urinary_frequency', label: 'Urinary Frequency'}, {
            name: 'burning_micturition', label: 'Burning Micturition'
        }, {name: 'hematuria', label: 'Hematuria'}, {name: 'flank_pain', label: 'Flank Pain'}, {
            name: 'stone_history', label: 'Stone History'
        }, {name: 'prostate_symptoms', label: 'Prostate Symptoms'},],
        GENERAL_SURGERY: [{name: 'lump_site', label: 'Lump Site'}, {
            name: 'lump_size', label: 'Lump Size'
        }, {name: 'tenderness', label: 'Tenderness'}, {
            name: 'reducibility', label: 'Reducibility (Hernia)'
        }, {name: 'cough_impulse', label: 'Cough Impulse'}, {
            name: 'previous_surgery', label: 'Previous Surgery History'
        },],
        ENT: [{name: 'ear_discharge', label: 'Ear Discharge'}, {
            name: 'hearing_loss', label: 'Hearing Loss'
        }, {name: 'nasal_block', label: 'Nasal Block'}, {
            name: 'throat_pain', label: 'Throat Pain'
        }, {name: 'voice_change', label: 'Voice Change'}, {name: 'tinnitus', label: 'Tinnitus'},],
        PLASTIC_SURGERY: [{name: 'scar_type', label: 'Scar Type'}, {
            name: 'burn_degree', label: 'Burn Degree'
        }, {name: 'wound_status', label: 'Wound Status'}, {
            name: 'cosmetic_concern', label: 'Cosmetic Concern'
        }, {name: 'reconstruction_need', label: 'Reconstruction Need'},],
        PULMONOLOGY: [{name: 'cough_duration', label: 'Cough Duration'}, {
            name: 'sputum', label: 'Sputum'
        }, {name: 'breathlessness', label: 'Breathlessness'}, {
            name: 'wheezing', label: 'Wheezing'
        }, {name: 'smoking_history', label: 'Smoking History'}, {name: 'chest_exam', label: 'Chest Examination'},],
        NEUROLOGY: [{name: 'headache_type', label: 'Headache Type'}, {
            name: 'seizure_history', label: 'Seizure History'
        }, {name: 'weakness', label: 'Weakness'}, {name: 'sensory_loss', label: 'Sensory Loss'}, {
            name: 'speech_issue', label: 'Speech Issue'
        }, {name: 'gait', label: 'Gait'},],
        GYNAEC_OBSTETRIC: [{name: 'menstrual_history', label: 'Menstrual History'}, {
            name: 'obstetric_history', label: 'Obstetric History'
        }, {name: 'pregnancy_status', label: 'Pregnancy Status'}, {
            name: 'pv_bleeding', label: 'PV Bleeding'
        }, {name: 'discharge', label: 'Discharge'}, {name: 'contraceptive_use', label: 'Contraceptive Use'},],
        NEPHROLOGY: [{name: 'edema', label: 'Edema'}, {
            name: 'urine_output', label: 'Urine Output'
        }, {name: 'creatinine_level', label: 'Creatinine Level'}, {
            name: 'dialysis_history', label: 'Dialysis History'
        }, {name: 'electrolyte_imbalance', label: 'Electrolyte Imbalance'},],
        PAEDIATRIC: [{name: 'fever_duration', label: 'Fever Duration'}, {
            name: 'feeding', label: 'Feeding'
        }, {name: 'growth_development', label: 'Growth & Development'}, {
            name: 'immunization', label: 'Immunization Status'
        }, {name: 'activity', label: 'Activity Level'},],
    };
    const deptKey = departments?.replace(/\s+/g, '_').toUpperCase();
    const deptFields = departmentFields[deptKey] || [];
    useEffect(() => {
        if (!deptFields.length) return;
        const initialFields = {};
        deptFields.forEach(f => {
            initialFields[f.name] = '';
        });
        setTranscripts(prev => ({
            ...initialFields, ...prev
        }));
    }, [deptKey]);
    const languages = [{
        no: "16", name: "English", native: "English", code: "en",
    }, {
        no: "1", name: "Afrikaans", native: "Afrikaans", code: "af",
    }, {
        no: "2", name: "Albanian", native: "Shqip", code: "sq",
    }, {
        no: "3", name: "Arabic", native: "عربي", code: "ar",
    }, {
        no: "4", name: "Armenian", native: "Հայերէն", code: "hy",
    }, {
        no: "5", name: "Azerbaijani", native: "آذربایجان دیلی", code: "az",
    }, {
        no: "6", name: "Basque", native: "Euskara", code: "eu",
    }, {
        no: "7", name: "Belarusian", native: "Беларуская", code: "be",
    }, {
        no: "8", name: "Bulgarian", native: "Български", code: "bg",
    }, {
        no: "9", name: "Catalan", native: "Català", code: "ca",
    }, {
        no: "10", name: "Chinese (Simplified)", native: "中文简体", code: "zh-CN",
    }, {
        no: "11", name: "Chinese (Traditional)", native: "中文繁體", code: "zh-TW",
    }, {
        no: "12", name: "Croatian", native: "Hrvatski", code: "hr",
    }, {
        no: "13", name: "Czech", native: "Čeština", code: "cs",
    }, {
        no: "14", name: "Danish", native: "Dansk", code: "da",
    }, {
        no: "15", name: "Dutch", native: "Nederlands", code: "nl",
    }, {
        no: "17", name: "Estonian", native: "Eesti keel", code: "et",
    }, {
        no: "18", name: "Filipino", native: "Filipino", code: "tl",
    }, {
        no: "19", name: "Finnish", native: "Suomi", code: "fi",
    }, {
        no: "20", name: "French", native: "Français", code: "fr",
    }, {
        no: "21", name: "Galician", native: "Galego", code: "gl",
    }, {
        no: "22", name: "Georgian", native: "ქართული", code: "ka",
    }, {
        no: "23", name: "German", native: "Deutsch", code: "de",
    }, {
        no: "24", name: "Greek", native: "Ελληνικά", code: "el",
    }, {
        no: "25", name: "Haitian Creole", native: "Kreyòl ayisyen", code: "ht",
    }, {
        no: "26", name: "Hebrew", native: "עברית", code: "iw",
    }, {
        no: "27", name: "Hindi", native: "हिन्दी", code: "hi",
    }, {
        no: "28", name: "Hungarian", native: "Magyar", code: "hu",
    }, {
        no: "29", name: "Icelandic", native: "Íslenska", code: "is",
    }, {
        no: "30", name: "Indonesian", native: "Bahasa Indonesia", code: "id",
    }, {
        no: "31", name: "Irish", native: "Gaeilge", code: "ga",
    }, {
        no: "32", name: "Italian", native: "Italiano", code: "it",
    }, {
        no: "33", name: "Japanese", native: "日本語", code: "ja",
    }, {
        no: "34", name: "Korean", native: "한국어", code: "ko",
    }, {
        no: "35", name: "Latvian", native: "Latviešu", code: "lv",
    }, {
        no: "36", name: "Lithuanian", native: "Lietuvių kalba", code: "lt",
    }, {
        no: "37", name: "Macedonian", native: "Македонски", code: "mk",
    }, {
        no: "38", name: "Malay", native: "Malay", code: "ms",
    }, {
        no: "39", name: "Maltese", native: "Malti", code: "mt",
    }, {
        no: "40", name: "Norwegian", native: "Norsk", code: "no",
    }, {
        no: "41", name: "Persian", native: "فارسی", code: "fa",
    }, {
        no: "42", name: "Polish", native: "Polski", code: "pl",
    }, {
        no: "43", name: "Portuguese", native: "Português", code: "pt",
    }, {
        no: "44", name: "Romanian", native: "Română", code: "ro",
    }, {
        no: "45", name: "Russian", native: "Русский", code: "ru",
    }, {
        no: "46", name: "Serbian", native: "Српски", code: "sr",
    }, {
        no: "47", name: "Slovak", native: "Slovenčina", code: "sk",
    }, {
        no: "48", name: "Slovenian", native: "Slovensko", code: "sl",
    }, {
        no: "49", name: "Spanish", native: "Español", code: "es",
    }, {
        no: "50", name: "Swahili", native: "Kiswahili", code: "sw",
    }, {
        no: "51", name: "Swedish", native: "Svenska", code: "sv",
    }, {
        no: "52", name: "Thai", native: "ไทย", code: "th",
    }, {
        no: "53", name: "Turkish", native: "Türkçe", code: "tr",
    }, {
        no: "54", name: "Ukrainian", native: "Українська", code: "uk",
    }, {
        no: "55", name: "Urdu", native: "اردو", code: "ur",
    }, {
        no: "56", name: "Vietnamese", native: "Tiếng Việt", code: "vi",
    }, {
        no: "57", name: "Welsh", native: "Cymraeg", code: "cy",
    }, {
        no: "58", name: "Yiddish", native: "ייִדיש", code: "yi",
    },];
    useEffect(() => {
        fetchData();
        fetchconsData();
    }, []);
    function fetchData() {
        axios.get(baseUrl + "edit-ip-admit/" + ip_id + "/")
            .then(response => {
                setIpData([response.data]);
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchconsData() {
        axios.get(baseUrl + "cons-search/")
            .then(response => {
                setConsData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleDateTimeChange = (datetime) => {
        setSelectedDateTime(datetime);
    };
    useEffect(() => {
        fetchcnotesData();
    }, []);
    function fetchcnotesData() {
        axios.get(baseUrl + "view-consult-note/" + ip_id + "/")
            .then(response => {
                setcnotesData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const formconsSubmit = (e) => {
        e.preventDefault();
        const cons = document.getElementById("cons").value;
        const notes_time = document.getElementById("notes_time").value;
        const _formData = new FormData();
        _formData.append('ip', ip_id);
        _formData.append('cons', cons);
        const deptKey = departments?.replace(/\s+/g, '_').toUpperCase();
        const deptFields = departmentFields[deptKey] || [];
        const deptData = {};
        deptFields.forEach(field => {

const previousNotes = cnotesData?.[0]?.notes;

let parsedPreviousNotes = {};

if (previousNotes) {
    try {
        parsedPreviousNotes =
            typeof previousNotes === "string"
                ? JSON.parse(previousNotes)
                : previousNotes;
    } catch (error) {
        console.error("Could not parse previous consultant notes:", error);
    }
}

deptFields.forEach(field => {
    const value =
        transcripts[field.name] ??
        parsedPreviousNotes?.[field.name] ??
        "";

    console.log("Dept Field:", field.name, value);
    deptData[field.name] = value;
});

        });
        _formData.append('notes', JSON.stringify(deptData));
        _formData.append('notes_time', notes_time);
        _formData.append('status', '1');
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        axios.post(`${baseUrl}consult-note-create/`, _formData)
            .then(response => {
                if (response.status == 200 || response.status == 201) {
                    Swal.fire({
                        title: 'Notes Created Succesfully', icon: 'success', timer: 2000, showConfirmButton: false
                    });
                    setconNoteData({
                        ip: '', notes: '', notes_time: '', status: '', addedby: '', ip_add: '',
                    });
                    setTimeout(() => {
                        window.location.href = '/ip-cons-detail/' + ip_id + '/';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire('Error!', 'Failed. Please try again later.', 'error');
            });
    };
    const handleconsDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you Sure you want to delete this',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-consult-note/' + id + '/')
                        .then(function (response) {
                            Swal.fire('success', 'Data has been Deleted');
                        });
                    setTimeout(() => {
                        window.location.href = ('/ip-cons-detail/' + ip_id + '/');
                    }, 2000);
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        })
    }
    return (
        <section className="container mt-4">
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-stethoscope" aria-hidden="true" style={{color: 'red'}}></i>
                Primary Consultant - Dr.{ipData.map(row => row.primary_consult.consultant)}
            </h3>
            <div className="table-responsive">
                <table className="erp-table-modern">
                    <thead>
                    <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                        <th>Patient</th>
                        <th>IP ID</th>
                        <th>Patient ID</th>
                        <th>Patient Name</th>
                        <th>Gender</th>
                        <th>D.O.B/Age</th>
                        <th>Mobile</th>
                        <th>Regd. On</th>
                    </tr>
                    </thead>

                    <tbody>
                    {ipData.map((patientData, index) => (
                        <tr>
                            <td><img src={patientData.profile_pic} alt="Thumbnail" className="thumbnail"
                                     style={{width: 120, height: 60}}/></td>
                            <td>{patientData.ip_id}</td>
                            <td>{patientData.pat.pat_id}</td>
                            <td>{patientData.pat.patient}</td>
                            <td>{patientData.pat.gender}</td>
                            <td>{patientData.pat.age}</td>
                            <td>{patientData.pat.mobile}</td>
                            <td>{formatDateTime(patientData.admit_date)}</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                <i className="fa-solid fa-user-doctor" aria-hidden="true" style={{color: 'red'}}></i>
                Consultant Notes
            </h3>
            <form>
                <div className="row">
                    <div className="col-md-3">
                        <label htmlFor="Notes" className="form-label">Consultant : </label>
                        <select
                            name="cons"
                            id="cons"
                            className="form-control"
                            onChange={(e) => {
                                const selectedId = e.target.value;
                                const selectedConsultant = consData.find(c => String(c.id) === String(selectedId));
                                // 🔥 IMPORTANT: set department here
                                setDepartments(selectedConsultant?.department || '');
                            }}
                        >
                            <option> --SELECT CONSULTANT--</option>
                            {consData.map((consultant, index) => (<option key={index} value={consultant.id}>
                                {consultant.consultant} - {consultant.department}
                            </option>))}
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="Notes Time" className="form-label">Notes Time : </label>
                        <DatePicker className="form-control" name="notes_time" id="notes_time"
                                    selected={selectedDateTime}
                                    onChange={handleDateTimeChange}
                                    dateFormat="yyyy-MM-dd h:mm"
                                    showTimeSelect
                                    timeIntervals={15}
                                    timeCaption="Time"
                        />
                    </div>
                </div>
                <div className="row">
                    <h3 className="text-center mt-3" style={{
                        color: 'black',
                        backgroundColor: '#e5eaef',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>

                        Casesheet
                    </h3>
                    {departments !== "DENTAL" && deptFields.length > 0 && deptFields.map(field => (
                        <div className="col-md-3 mb-3 mt-3" key={field.name}>

                            <label className="form-label">{field.label}</label>

                            <textarea
                                className="form-control"
                                name={field.name}
                                value={transcripts[field.name] || conNoteData?.[field.name] || cnotesData?.[0]?.notes?.[field.name] || ''}
                                onChange={(e) => {
                                    setTranscripts(prev => ({
                                        ...prev, [field.name]: e.target.value
                                    }));
                                }}
                            />


                            {/* 🎤 MIC STOP */}
                            <button
                                className="btn btn-outline-danger ms-2 mt-2"
                                onClick={(e) => {
                                    e.preventDefault();
                                    stopListening(); // ✅ use your function
                                }}
                            >
                                <i className="fa fa-microphone-lines-slash"></i>
                            </button>

                            {/* 🎤 MIC START */}
                            <button
                                type="button"
                                className="btn btn-outline-success ms-2 mt-2"
                                onClick={(e) => {
                                    e.preventDefault();
                                    startListeningForField(field.name);
                                }}
                            >
                                <i className="fa fa-microphone-lines"></i>
                            </button>
                        </div>))}
                </div>
                <div style={{
                    display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'
                }}
                     className='ms-5 mb-5'>
                    <button type="button" onClick={formconsSubmit} className="btn btn-primary mt-4">Submit
                    </button>
                </div>
            </form>
            <div className="card card-body">
                <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                    <i className="fa-solid fa-user-doctor" aria-hidden="true" style={{color: 'red'}}></i>
                    Consultant Notes History
                    <i className="fa-brands fa-discourse"></i>
                </h3>
                <div className="table-responsive">
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th>Date</th>
                            <th>Consultant</th>
                            <th>Notes</th>
                            <th>Delete</th>
                        </tr>
                        </thead>
                        <tbody>
                        {cnotesData.map((dis, index) => (<tr>
                            <td>{formatDateTime(dis.notes_time)}</td>
                            <td>{dis.cons.consultant}</td>
                            <td>
                                {dis.notes && (() => {
                                    try {
                                        const data = JSON.parse(dis.notes);
                                        return Object.entries(data).map(([key, value]) => (<div key={key}>

                                            {key.replace(/_/g, ' ').toUpperCase()}:
                                            <strong> {value || '-'}</strong>
                                        </div>));
                                    } catch (e) {
                                        return dis.notes; // fallback if not JSON
                                    }
                                })()}
                            </td>
                            <td>
                                <button className="btn btn-outline-danger" type="button"
                                        onClick={() => handleconsDelete(dis.id)}>
                                    Delete
                                </button>
                            </td>
                        </tr>))}
                        </tbody>
                    </table>
                </div>
            </div>

        </section>
    )
}
export default ConsultNotes;